module.exports = __webpack_public_path__ + "assets/pin-selected.1bc3af9a.svg";